import { Controller } from "@hotwired/stimulus";

// Une ligne « jour » de la fiche de souhaits d'emploi du temps : le moment et
// les plages ne se montrent que pour un jour coché, et la liste des plages
// seulement quand le moment est « Plages précises » (elle disparaît au matin,
// à l'après-midi ou à la journée).
export default class extends Controller {
  static targets = ["wanted", "momentField", "periods"];

  connect() {
    this.refresh();
  }

  refresh() {
    const wanted = this.hasWantedTarget ? this.wantedTarget.checked : true;
    // Le choix du moment vit dans l'input caché du select du design system.
    const input = this.hasMomentFieldTarget ? this.momentFieldTarget.querySelector("input[type=hidden]") : null;
    const moment = input ? input.value : "";
    if (this.hasMomentFieldTarget) this.momentFieldTarget.hidden = !wanted;
    if (this.hasPeriodsTarget) this.periodsTarget.hidden = !(wanted && moment === "periods");
  }
}
